export default __webpack_public_path__ + "static/media/dole-juice-module-hero-mobile@2x.d349399a.png";